var _rect, _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChatEndIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#ED1C24"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_146_26509)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.3144 11.051C22.9677 10.4021 21.4919 10.0656 19.9969 10.0664C18.2001 10.067 16.4369 10.5549 14.8955 11.4782C13.354 12.4016 12.0919 13.7257 11.2434 15.3097C10.395 16.8936 9.99209 18.678 10.0776 20.4729C10.1572 22.1441 10.6576 23.766 11.5295 25.1893L10.1092 28.9682C10.0187 29.2088 10.0646 29.4795 10.2292 29.6769C10.3938 29.8743 10.6519 29.9681 10.9049 29.9223L15.8563 29.0271C17.141 29.6172 18.5378 29.9266 19.9534 29.9336C21.4484 29.9411 22.9257 29.6109 24.2754 28.9679C25.625 28.3248 26.8122 27.3855 27.7482 26.2198C28.6842 25.0541 29.345 23.6921 29.6814 22.2355C30.0179 20.7788 30.0212 19.265 29.6912 17.8069C29.361 16.3488 28.7062 14.984 27.7752 13.8143C26.8443 12.6445 25.6613 11.6999 24.3144 11.051Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_146_26509)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2194 15.2092C15.9404 14.9303 15.4882 14.9303 15.2092 15.2092C14.9303 15.4882 14.9303 15.9404 15.2092 16.2194L18.9899 20L15.2092 23.7806C14.9303 24.0596 14.9303 24.5119 15.2092 24.7908C15.4882 25.0697 15.9404 25.0697 16.2194 24.7908L20 21.0101L23.7806 24.7908C24.0596 25.0697 24.5119 25.0697 24.7908 24.7908C25.0697 24.5119 25.0697 24.0596 24.7908 23.7806L21.0101 20L24.7908 16.2194C25.0697 15.9404 25.0697 15.4882 24.7908 15.2092C24.5119 14.9303 24.0596 14.9303 23.7806 15.2092L20 18.9899L16.2194 15.2092Z",
    fill: "#ED1C24"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_146_26509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_146_26509"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(15 15)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatEndIcon);
export default __webpack_public_path__ + "static/media/chat-end-icon.1be4dd863b723b87ddb0a5e8872f0e98.svg";
export { ForwardRef as ReactComponent };